module.exports = __webpack_public_path__ + "static/img/home_data_2.9985054.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_data_2.png
// module id = ak6l
// module chunks = 1